/* eslint-disable no-console */
import { AnyAction } from '@reduxjs/toolkit';
import { ERROR_SUFFIX } from 'lib/constants/network';
import { multiClientMiddleware } from 'redux-axios-middleware';
import { RootDispatch } from 'store/types';
import axiosClients from './axiosClients';
import { axiosMiddlewareSuccessOverride } from './axiosMiddlewareSuccessOverride';
import requestInterceptors from './requestInterceptors';
import responseInterceptors from './responseInterceptors';

const options = {
  onError: ({
    action,
    dispatch,
    error
  }: {
    action: AnyAction;
    dispatch: RootDispatch;
    error: Error | string;
  }) => {
    return dispatch({
      type: `${action.type}${ERROR_SUFFIX}`,
      error,
      meta: {
        previousAction: action
      }
    });
  },
  onSuccess: axiosMiddlewareSuccessOverride,
  interceptors: {
    request: requestInterceptors,
    response: responseInterceptors
  }
};

const axiosMiddleware = multiClientMiddleware(axiosClients, options);

export default axiosMiddleware;
